// extracted by mini-css-extract-plugin
var _1 = "DocFlowTableRowFile-moduleinfo__C8opD TableCellInfo-moduleTableCellInfo__ILZHF IconNG-moduleiconContainer__SxWZ0";
export { _1 as "info" }
